import { createFileRoute, Link } from '@tanstack/react-router'
import { NAVIGATION_ICONS } from './-components/shared/navigation-config'
import { useLingui } from '@lingui/react/macro'
import { Logo } from './-components/shared/logo'
import { useAppStore } from '@/lib/app-store'
import { Animate } from './-components/animate'
import { PageLayout, ScrollableContent, ScrollableArea } from './-components/shared/layout'
import { BreadcrumbTrail } from './-components/title-section'
import { ReportComponent } from './-components/report/report'
import { ReportPaneSkeleton } from './-components/app-layout-skeleton'
import { reportSearchDeps, reportQueryOptions, useReport } from '@/hooks/use-report'
import { clearProfileSelection } from '@/hooks/use-root-search'
import { noop } from '@tanstack/react-query'

export const Route = createFileRoute('/_app/market')({
  loaderDeps: ({ search }) => reportSearchDeps(search),
  context: ({ deps, params }) => ({
    reportQueryOptions: reportQueryOptions(deps, params, 'market'),
  }),
  loader: ({ context }) => {
    if (context.reportQueryOptions) context.queryClient.query(context.reportQueryOptions).catch(noop)
  },
  component: RouteComponent,
  pendingComponent: ReportPanePending,
})

function ReportPanePending() {
  return (
    <Animate className="h-full">
      <ReportPaneSkeleton />
    </Animate>
  )
}

function RouteComponent() {
  const { t } = useLingui()
  const extension = useAppStore((state) => state.store.extension)
  const callback = useAppStore((state) => state.store.callback)
  const context = Route.useRouteContext()
  const { report, isFetching } = useReport(context.reportQueryOptions)

  const breadcrumbs = [
    {
      label: t`Market`,
      link: (
        <Link
          to="/market"
          search={(prev) => ({
            ...clearProfileSelection(prev),
            first: { type: 'market' },
          })}
        >
          {t`Market`}
        </Link>
      ),
    },
  ]

  return (
    <>
      <div id="report" className="@container flex h-full flex-col">
        {extension && <Logo openInNewTab />}
        <PageLayout
          icon={NAVIGATION_ICONS.market}
          title={t`Market`}
          breadcrumbsSlot={<BreadcrumbTrail items={breadcrumbs} />}
        >
          <ScrollableContent>
            <ScrollableArea>
              <ReportComponent report={report} isFetching={isFetching} callback={callback} />
            </ScrollableArea>
          </ScrollableContent>
        </PageLayout>
      </div>
    </>
  )
}
